import "./equalizer.css";

const EQULIZER_STATE_LIST = [
  { height: "h-[20px]", duration: "1.2s" },
  { height: "h-[38px]", duration: "1s" },
  { height: "h-[26px]", duration: "1.1s" },
];

const Equalizer = ({ isPlay }: { isPlay: boolean }) => {
  return (
    <div id="equalizer" className="flex items-end gap-[2px] h-9 mx-9">
      {EQULIZER_STATE_LIST.map((equalizerState) => {
        return (
          <div
            key={equalizerState.duration}
            style={{ animationDuration: `${equalizerState.duration}` }}
            className={`w-[10px] bg-white rounded ${equalizerState.height} ${
              isPlay && "active"
            }`}
          ></div>
        );
      })}
    </div>
  );
};

export default Equalizer;
